export enum EStats {
    kredit = "kredit",
    darkMatter = "darkMatter",
    token = "token",
    lp = "lp",
    cp = "cp",
    ton = "ton",
}